import { Layout } from "antd";
import styled from "styled-components";

const { Content } = Layout;
export const StyledContent = styled(Content)`
  height: calc(100vh - 5rem);
  overflow: auto;
  padding: 0.5rem;
  background: #f0f2f5;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.1);
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: rgba(0, 0, 0, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    &:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }
  &::-webkit-scrollbar-corner {
    background: rgba(0, 0, 0, 0.1);
  }
`;
